import React, { ReactNode } from 'react';
import RagFlowIdContext from 'new/components/flows/types/genai_rag/context/RagFlowId/RagFlowIdContext';

export default function RagFlowIdProvider({
  children,
  flowId,
}: {
  children: ReactNode;
  flowId: number;
}) {
  return <RagFlowIdContext.Provider value={flowId}>{children}</RagFlowIdContext.Provider>;
}
